<template>
	<div
		class="tags-row"
		v-if="item.product.sell_out[people] > 0"
	>
		<div class="tag">+ {{ $t("general.currency") }} {{ (item.product.sell_out[people]/people).toFixed(2).replace(".", ",") }} a porzione</div>
	</div>
</template>

<script type="text/javascript">

export default {
	props: ['item', 'people']
}
</script>

<style scoped>

	.tags-row > .tag {
		text-transform: uppercase;
		display: inline-block;
		background: #E5C100;
		color: white;
		font-weight: bold;
		border-radius: 6px;
		padding: 0px 5px;
		margin-top: 2px;
		z-index: 2;
		border: 1.5px solid white;
    font-size: 13px;
	}

	@media (min-width: 320px) and (max-width: 350px) {
		.tags-row > .tag {
			border-radius: 0;
			border: none;
			font-size: 10px;
			margin-top: 50%;
		}
	}

	@media (min-width: 351px) and (max-width: 430px) {
		.tags-row > .tag {
			border-radius: 0;
			border: none;
			font-size: 11px;
			margin-top: 60%;
		}
	}

	@media (min-width: 430px) and (max-width: 768px) {
		.tags-row > .tag {
			border-radius: 0;
			border: none;
			font-size: 11px;
			margin-top: 70%;
		}
	}

	@media (min-width: 768px) and (max-width: 1024px) {
		.tags-row > .tag {
			border-radius: 0;
			border: none;
			font-size: 14px;
			margin-top: 90%;
		}
	}

</style>
